export class ContentHistoryService {
  constructor(data) {
    this.data = data;
  }

  getContentHistory(contentId, pageSize = 10, page = 1, lang) {
    return this.data.getContentHistory(contentId, pageSize, page, lang);
  }
}
